import React from 'react';
import styles from './wish-list-item.module.scss';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { useLocalizedPriceFormatter } from 'tradera/localization/use-localized-price-formatter';
import * as itemActions from 'tradera/state/items/actions';
import { EndTimeLabel } from './end-time-label';
import itemTypes from 'tradera/constants/item-types';
import { WishListButton } from './wish-list-button';
import { ActionButton } from './action-button';
import { useDispatch } from 'react-redux';

export const ItemDetailsMobile = ({ item, existsInState, onGoToVipClick }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const localizedPriceFormatter = useLocalizedPriceFormatter();

    const dispatch = useDispatch();
    const onWishListButtonClick = (itemId) =>
        dispatch(itemActions.wishlist(itemId));

    const isShopItem = item.itemType === itemTypes.SHOP_ITEM;

    return (
        <div className={`flex-grow-1 ${styles.itemDetailsMobile}`}>
            <div className="d-flex mb-1 justify-content-between">
                <a
                    href={toLocalizedUrl(item.itemUrl)}
                    onClick={onGoToVipClick}
                    className="size-london text-inter-medium text-truncate mr-1">
                    {item.shortDescription}
                </a>
                <WishListButton
                    toggled={existsInState}
                    showText={false}
                    onClick={() => onWishListButtonClick(item.itemId)}
                />
            </div>
            <div className="d-flex mb-1 align-items-baseline justify-content-between">
                {!isShopItem ? (
                    <EndTimeLabel time={item.endDate} />
                ) : (
                    <span className="text-muted">
                        {t('myt_listItem_fixedPrice')}
                    </span>
                )}
                <span className="text-inter-heavy">
                    {localizedPriceFormatter(item.price)}
                </span>
            </div>
            <div className="d-flex mb-1 align-items-baseline justify-content-between">
                <span className="text-muted">
                    {t('myt_listItem_shippingPrice', {
                        price: localizedPriceFormatter(
                            item.preferredShipping.cost
                        )
                    })}
                </span>
                {!isShopItem && item.itemType !== itemTypes.PURE_BIN && (
                    <a
                        href={item.itemUrl}
                        onClick={onGoToVipClick}
                        className="link text-inter-medium">
                        {t('myt_listItem_numberOfBidsWithCount', {
                            count: item.totalBids
                        })}
                    </a>
                )}
            </div>
            <div className="d-flex mb-2 align-items-baseline justify-content-between">
                <a
                    href={toLocalizedUrl(
                        `/profile/items/${
                            item.sellerMemberId
                        }/${encodeURIComponent(item.sellerAlias)}`
                    )}
                    className="link text-inter-medium text-truncate mr-2">
                    {item.sellerAlias}
                </a>
                {!!item.maxBidAmount && (
                    <span className="text-muted text-no-wrap">
                        {t('myt_listItem_maxBidAmount', {
                            amount: localizedPriceFormatter(item.maxBidAmount)
                        })}
                    </span>
                )}
            </div>
            <div className="d-flex align-items-baseline justify-content-between">
                <ActionButton item={item} />
            </div>
        </div>
    );
};
